<template>
	<div
		class="cetin-data"
		v-if="results && results.length"
	>

		<div style="font-size: 28px; color: red;">
			Pozor, na této adrese je evidovaný dlužník
		</div>

		<div
			v-for="dluznik of results"
			:key="dluznik.data.cislo_sml"
			class="dluznici"
		>
			<div>
				Jméno: {{ dluznik.data.name }} {{ dluznik.data.surname }}
			</div>
			<div>Narození: {{ dluznik.data.narozeni }}</div>
			<div>
				Rč: {{ dluznik.data.rc ? dluznik.data.rc : "Nemáme" }}
			</div>
			<div>
				Adresa:
				{{ dluznik.data.adresa ? dluznik.data.adresa : "Nemáme" }}
			</div>
			<div>
				Město:
				{{ dluznik.data.mesto ? dluznik.data.mesto : "Nemáme" }}
			</div>
			<div>
				Telefon:
				{{ dluznik.data.telefon ? dluznik.data.telefon : "Nemáme" }}
			</div>
			<div>
				Email:
				{{ dluznik.data.email ? dluznik.data.email : "Nemáme" }}
			</div>
			<div>
				Služba:
				{{ dluznik.data.sluzba ? dluznik.data.sluzba : "Nemáme" }}
			</div>
			<div>
				Radius:
				{{ dluznik.data.radius ? dluznik.data.radius : "Nemáme" }}
			</div>
			<div>
				Číslo smlouvy:
				{{
					dluznik.data.cislo_sml
						? dluznik.data.cislo_sml
						: "Nemáme"
				}}
			</div>
			<div>
				Sepisoval:
				{{
					dluznik.data.sepisoval
						? dluznik.data.sepisoval
						: "Nemáme"
				}}
			</div>
			<div>
				Platí za měsíc:
				{{
					dluznik.data.plati_za_mesic
						? dluznik.data.plati_za_mesic
						: "Nemáme"
				}}
			</div>
			<div>
				Žádost o připojení:
				{{
					dluznik.data.zadost_o_pripojeni
						? dluznik.data.zadost_o_pripojeni
						: "Nemáme"
				}}
			</div>
			<div>
				Pronájem:
				{{
					dluznik.data.pronajem ? dluznik.data.pronajem : "Nemáme"
				}}
			</div>
			<div>Poznámka: {{ dluznik.data.poznamka }}</div>
			<div>
				Datum aktivace:
				{{
					dluznik.data.datum_aktivace
						? dluznik.data.datum_aktivace
						: "Nemáme"
				}}
			</div>
			<div>
				Dluhy:
				{{ dluznik.data.dluhy ? dluznik.data.dluhy : "Nemáme" }}
			</div>
			<div>
				Zbývá uhradit:
				{{
					dluznik.data.zbyva_uhradit
						? dluznik.data.zbyva_uhradit
						: "Nemáme"
				}}
			</div>
			<div>
				Výsledek:
				{{
					dluznik.data.vysledek ? dluznik.data.vysledek : "Nemáme"
				}}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DluzniciResult',

	props: {
		results: { type: Array, default: {} }
	},
}
</script>

<style lang="stylus" scoped>
.cetin-data
	padding-top 10px
	margin-top 15px
	border-bottom 1px solid #4CA5F9
	border-top 1px solid #4CA5F9

.dluznici
	display flex
	flex-direction column
	text-align left

</style>
	


// WEBPACK FOOTER //
// src/components/search_provider/results/DluzniciResult.vue